import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
import { useBooking } from './BookingContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const {
    openBooking
  } = useBooking();
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 50);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  const navLinks = [{
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'Platform',
    href: '#platform'
  }, {
    name: 'Industries',
    href: '#solutions'
  }, {
    name: 'About',
    href: '#about'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: isVisible ? 0 : -100
  }} transition={{
    duration: 0.3,
    ease: 'easeInOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#050505]/80 backdrop-blur-xl border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-352">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-353">
        <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-354">
          <Logo className="text-3xl" dotClassName="w-2 h-2 ml-1" data-id="element-355" />
        </a>

        <div className="hidden md:flex items-center space-x-8" data-id="element-356">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-400 hover:text-white transition-colors relative group" data-id="element-357">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-brand-orange transition-all duration-300 group-hover:w-full" data-id="element-358" />
            </a>)}
        </div>

        <div className="flex items-center space-x-6" data-id="element-359">
          <a href="#contact" className="hidden md:block text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-360">
            Contact
          </a>
          <button onClick={openBooking} className="bg-white/5 hover:bg-white/10 border border-white/10 hover:border-brand-orange/50 text-white text-sm font-medium px-6 py-2.5 rounded-full transition-all duration-300 shadow-[0_0_0_rgba(219,127,74,0)] hover:shadow-[0_0_20px_rgba(219,127,74,0.2)]" data-id="element-361">
            Book a Demo
          </button>
        </div>
      </div>
    </motion.nav>;
}